import { Component, Input, OnInit, Output, EventEmitter } from '@angular/core';
import { QueovalParam, BreadDik } from '../../models';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';

@Component({
  // tslint:disable-next-line:component-selector
  selector: 'q-action-co',
  templateUrl: './action-co.component.html',
  styleUrls: ['./action-co.component.css']
})

export class ActionCoComponent implements OnInit {

  public src: SafeResourceUrl | null;
  constructor(
    protected domSanitizer: DomSanitizer
  ) { }

  @Input('param') param: QueovalParam;
  @Output() save: EventEmitter<void> = new EventEmitter<void>();

  ngOnInit(): void {
    const BdSrc: BreadDik | undefined = this.param.params.find((obj: BreadDik) => obj.key === 'src');
    this.src = BdSrc ? this.domSanitizer.bypassSecurityTrustResourceUrl(BdSrc.value.toString()) : null;
  }

  public onLoad(): void {
    let iWindow: any = null;
    let doc: any = null;
    const iframe: any = document.getElementById('iframe1');
    if (iframe) {
      iWindow = iframe.contentWindow;
      doc = iframe.contentDocument || iframe.contentWindow.document;
    }
    if (doc) {
      doc.getElementsByTagName('body')[0].style.paddingLeft = '15px';
      doc.getElementsByTagName('body')[0].style.paddingRight = '15px';
      const update: any = doc.getElementsByName('barreBOA$btnSav');
      if (update && update.length > 0) {
        update[0].addEventListener('click', this.Save);
      }
      const create: any = doc.getElementsByName('bo_F$ctbTitre$btnEnregistrer');
      if (create && create.length > 0) {
        create[0].addEventListener('click', this.Save);
      }
    }
    if (localStorage.getItem('queoval-action-co-saved')) {
      localStorage.removeItem('queoval-action-co-saved');
      this.save.emit();
    }
  }

  public Save(): void {
    localStorage.setItem('queoval-action-co-saved', 'true');
  }
}


